<!-- 
 * @Descripttion: 
 * @Author: sjq
 * @Date: 2023-08-04 15:16:59
 * @LastEditors: sjq
 * @LastEditTime: 2024-01-05 16:20:46
 -->
<template>
  <div class="minheight100">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header bgcolor="#00B25A" :transparent="true" :title="title" back-type="back-app" :needRight="false">
      <div class="header_icon_box" @click="iconClick" name="right">规则</div>
    </app-header>

    <div class="container">
      <div class="top_box">
        <!-- <div @click="iconClick" class="commit">
          <span>当前积分</span>
          <img src="../../images/integral/integral_rule_icon.png" alt="" width="14" />
        </div> -->
        <div class="expiredVal_box">
          <div class="expiredVal">
            {{ goodsIndexInfo.available }}
          </div>
          <div class="top_right_box">
            <div class="commit" @click="goLog">
              <span>积分明细</span>
            </div>
            <div class="commit-1">|</div>
            <div class="commit" @click="iconClick">
              <span>积分规则</span>
            </div>
          </div>
        </div>
      </div>
      <div class="activity-box" v-if="activityList.length > 0">
        <div class="my-swiper">
          <swiper :options="swiperOption" :key="swiperKey" ref="mySwiper" class="swiper">
            <swiper-slide v-for="(item, index) in activityList" :key="index" class="swiper_item">
              <img :src="item.imgUrl" alt="" @click="goActivity(item)" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="content" ref="content">
        <div class="title">可兑换商品</div>
        <!-- <img class="call_box" ref="contentImg" @click="goCall" src="../../images/integral/call_btn.png" alt="" /> -->
        <!-- <Sticky :offset-top="appUser.isNative ? parseInt(appUser.appStatusBarHeight || 0) + 44 : 0" @change="onChange">
          <div
            class="tabs"
            :class="{
              tabs_fixed: isFixed
            }"
          >
            <div
              class="tab"
              v-for="(item, index) in tabList"
              @click.stop="onClick(index)"
              :key="index"
              :class="{ tab_active: tabActive === index }"
            >
              <a @click.prevent="() => {}">{{ item.label }}</a>
            </div>
          </div>
          <div class="tab-bottom-btn" v-if="tabActive === 0">
            <span class="btn" :class="{ 'btn-active': isNewOnSale === 1 }" @click="setIsNewOnSale">上新</span>
          </div>
        </Sticky> -->
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text=""
            offset="10"
            @load="onLoad"
            style="min-height: 400px"
          >
            <ul class="flexbox list_box" v-if="goodsList.length > 0">
              <li class="list_item" v-for="(item, index) in goodsList" :key="index" @click="onItemClick(item)">
                <div :class="{ no_img: item.stockNum === 0 }">
                  <div class="new" v-if="item.isNewOnSale === 1">new</div>
                  <van-image width="100%" :src="item.coverUrl" />
                </div>
                <div class="flexbox item_info">
                  <div class="van-multi-ellipsis--l2 name">
                    {{ item.goodsName }}
                  </div>
                  <div class="price">{{ item.creditVal }}{{ integralName }}</div>
                </div>
              </li>
            </ul>
            <div v-else class="no-list">
              <img src="../../images/integral/no_list.png" alt="" />
              <div class="commit">
                {{ isNewOnSale === 1 ? '暂无新品' : tabActive === 1 ? '暂无可兑奖品' : '敬请期待' }}
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <!-- <div class="pop_style">
      <van-popup v-model="popupVisible" closeable :style="{ borderRadius: '10px' }" :close-on-click-overlay="false">
        <div class="pop_box">
          <div class="pop_title_box">分享活动规则</div>
          <what></what>
          <ul class="flexbox action_box">
            <li @click="popupVisible = false">我知道了</li>
            <li class="color_box" @click="goCall">立即去分享</li>
          </ul>
        </div>
      </van-popup>
    </div> -->
  </div>
</template>

<script>
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'
import { getPageUrl } from '@/utils/common/url'
import { Indicator } from 'mint-ui'
import { $openWebPage, $gotoPosterPage, $settingBounces, $dataHandle } from '@/utils/common/native-api'
import { integralName } from '@/pages/config'
import what from './integral-rule/what.vue'
import { saTrack } from '@/utils/common/shence'
import { Sticky, Toast } from 'vant'
import service from '@/api/modules/payment/integral'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { skipApp } from '@/utils/goApp'
import Body from '@/mixins/body'

export default {
  components: { what, Sticky, swiper, swiperSlide },
  data() {
    return {
      appUser,
      integralName,
      title: '积分商城',
      loaded: true, // 是否空数据
      refreshing: false,
      page: 0,
      goodsList: [],
      isLoading: false,
      finished: false,
      loading: false,
      popupVisible: false,
      tabActive: 0,
      tabList: [
        {
          label: '全部',
          value: {
            startValue: 0,
            endValue: 100000
          }
        },
        {
          label: '我能兑换的',
          value: {
            startValue: 0,
            endValue: 0
          }
        },
        {
          label: '7000以下',
          value: {
            startValue: 0,
            endValue: 7000
          }
        },
        {
          label: '7000-10000',
          value: {
            startValue: 7000,
            endValue: 10000
          }
        },
        {
          label: '10000以上',
          value: {
            startValue: 10000,
            endValue: 10000000
          }
        }
      ],
      appUser,
      isFixed: false,
      stickyTop: 0,
      isNewOnSale: null,
      activityList: [],
      swiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        spaceBetween: '-5%',
        slidesPerView: 'auto',
        initialSlide: 0, //默认显示第一张在中心位置
        loop: false,
        autoplay: false, // 是否自动播放
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 200,
          modifier: 1,
          slideShadows: false
        }
      },
      swiperKey: Math.random().toString(36).substr(2) /*随机的key*/
    }
  },
  created() {
    Indicator.open('加载中...')
    this.onLoad()
    this.getActivityList()
  },
  mounted() {
    $settingBounces({
      bounces: 'disenable'
    })
    // this.popNativeOption()
  },
  mixins: [Body],
  computed: {
    ...mapGetters('integral/index', ['goodsIndexInfo'])
  },
  methods: {
    popNativeOption() {
      const that = this
      // 取值
      $dataHandle({ getfirstPopBool: '' }, function (data) {
        console.log(typeof data, 'data data')
        if (typeof data === 'string') {
          data = JSON.parse(data)
        }
        if (data && data.getfirstPopBool) return
        else {
          that.popupVisible = true
          $dataHandle({ setfirstPopBool: new Date().getTime() })
        }
      })
    },
    onRefresh() {
      this.page = 0
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      // this.goodsList = []
      this.onLoad()
    },
    onLoad() {
      this.page += 1
      let data = this.tabList[this.tabActive].value
      this.$store
        .dispatch('integral/index/integralInfo', {
          currentPage: this.page,
          pageSize: 10,
          ...data,
          isNewOnSale: this.isNewOnSale
        })
        .then(res => {
          console.log(res, 'res')
          if (res.userCreditAccount && res.userCreditAccount.available) {
            this.tabList[1].value.endValue = res.userCreditAccount.available
          }
          Indicator.close()
          if (this.refreshing) {
            this.refreshing = false
          }
          const { list, total } = res.pageData
          this.loading = false
          this.isLoading = false
          if (this.goodsList.length === total) this.finished = true
          if (this.page === 1) {
            this.goodsList = list
          } else {
            this.goodsList = this.goodsList.concat(list)
          }
          const goodsList = document.querySelectorAll('.list_box .list_item .van-image')
          if (goodsList.length) {
            const wpx = goodsList[0].offsetWidth
            goodsList.forEach(item => {
              item.style.height = wpx + 'px'
            })
          }
        })
        .catch(() => {
          Indicator.close()
        })
    },
    // 规则
    iconClick() {
      if (appUser.isNative) {
        const url = getPageUrl({
          page: 'payment.html',
          route: '/integral-rule'
        })
        $openWebPage({
          url
        })
      } else {
        this.$router.push('integral-rule')
      }
    },
    // 商品详情
    onItemClick(item) {
      if (appUser.isNative) {
        $openWebPage({
          url: item.goodsLinkUrl
        })
      } else {
        window.location.href = item.goodsLinkUrl
      }
    },
    // 积分明细
    goLog() {
      if (appUser.isNative) {
        const url = getPageUrl({
          page: 'payment.html',
          route: '/integral-log'
        })
        $openWebPage({
          url
        })
      } else {
        this.$router.push('integral-log')
      }
    },
    // 分享海报页面
    goCall() {
      saTrack('integral_goPoster_click', {
        userId: appUser.userId
      })
      $gotoPosterPage()
      // const url = getPageUrl({
      //   page: 'share.html',
      //   route: '/call'
      // })
      // if (appUser.isNative) {

      // } else {
      //   window.location.href = url
      // }
    },
    onClick(index) {
      this.stickyTop = this.$refs.content.offsetTop
      this.$refs.content.style = `min-height: ${
        document.documentElement.clientHeight - this.$refs.content.offsetTop + 'px'
      } `
      if (document.body.scrollTop) {
        document.body.scrollTop = document.body.scrollTop < this.stickyTop ? document.body.scrollTop : this.stickyTop
      } else {
        document.documentElement.scrollTop =
          document.documentElement.scrollTop < this.stickyTop ? document.documentElement.scrollTop : this.stickyTop
      }

      console.log(document.documentElement.scrollTop, document.body.scrollTop, ';;;;;;1')
      this.tabActive = index
      if (index !== 0) {
        this.isNewOnSale = null
      }
      this.onRefresh()
    },
    onChange(e) {
      this.isFixed = e
      console.log(this.isFixed, e, 'this.isFixed')
    },
    onscroll(e) {
      console.log(e, 'ee')
    },

    setIsNewOnSale() {
      this.isNewOnSale = this.isNewOnSale === 1 ? null : 1
      this.onClick(this.tabActive)
    },
    getActivityList() {
      service.getActivityList().then(res => {
        console.log(res)
        this.activityList = res
      })
    },
    goActivity(data) {
      if (appUser.isNative) {
        // $openWebPage({
        //   url: data.linkUrl
        // })
        skipApp({
          type: 'gotoPosterPage',
          inner: 'gotoPosterPage',
          activityId: data.activityId,
          optionArr: ['type', 'activityId']
        })
      } else {
        location.href = data.linkUrl
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.pop_box {
  width: 80vw;
  padding: 0 24px;
  .pop_title_box {
    font-size: 0.36rem;
    font-weight: 600;
    text-align: center;
    padding: 0.48rem 0 0.2rem;
  }
  .action_box {
    padding: 20px 0 20px;
    justify-content: space-around;
    li {
      width: 2rem;
      height: 0.7rem;
      text-align: center;
      line-height: 0.68rem;
      background-color: red;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 6px;
      font-size: 0.26rem;
    }
    .color_box {
      background-color: #00b25a;
      color: #fff;
    }
  }
}
.header_icon_box {
  display: inline-block;
  text-align: right;
  font-size: 14px;
  img {
    display: block;
    width: 0.48rem;
    height: 0.48rem;
  }
}
.minheight100 {
  background: #f5f5f5;
}
.container {
  position: relative;
  width: 100%;
  min-height: 100%;
  background: #f5f5f5;
  padding: 0.16rem 0.24rem;
}
.top_box {
  position: relative;
  z-index: 1;
  color: rgba(255, 255, 255, 0.8);
  background: #00b25a;
  margin: -0.16rem -0.24rem;
  padding: 0.16rem 0.24rem 0.48rem;
  .expiredVal_box {
    display: flex;
    margin-top: 0.08rem;
    line-height: 1;
    align-items: flex-end;
    justify-content: space-between;
    .expiredVal {
      font-size: 0.64rem;
      font-weight: bold;
      color: #fff;
      margin-right: 0.08rem;
    }
    .top_right_box {
      display: flex;
      align-items: center;
      .commit-1 {
        margin: 0 0.16rem;
      }
    }
  }
  .commit {
    padding: 0.04rem 0;
    display: flex;
    align-items: center;
    img {
      margin-left: 0.08rem;
    }
  }
}

.content {
  // position: absolute;
  width: 100%;
  // top: 2.52rem;
  left: 0;
  z-index: 3;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  position: relative;
  z-index: 1;
  margin-top: 0.48rem;
  .title {
    font-size: 0.32rem;
    font-weight: bold;
  }
}
.call_box {
  display: block;
  width: 3.82rem;
  height: 0.82rem;
  margin: 1.16rem auto 0;
}
.list_box {
  flex-wrap: wrap;
  padding: 0.24rem 0rem;
  justify-content: space-between;
  align-items: flex-start;
  .list_item {
    width: calc(100% / 2 - 5px);
    border-radius: 0.16rem;
    background-color: #fff;
    margin-bottom: 0.32rem;
    overflow: hidden;
    position: relative;
    .new {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      background: linear-gradient(90deg, #ff9898 0%, #f74040 100%);
      color: #fff;
      padding: 0.01rem 0.1rem 0.05rem;
      padding-left: 0.3rem;
      border-end-start-radius: 0.5rem;
      font-size: 0.28rem;
    }
    .item_img_box {
      display: block;
      width: 100%;
      // height: 3.1rem;
    }
    .no_img {
      position: relative;
      &::before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        content: '';
        background: rgba(0, 0, 0, 0.4) url('../../images/icon/no_good.png') no-repeat center center;
        background-size: 65%;
        z-index: 2;
      }
    }
    .item_info {
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-around;
      padding: 0 0.15rem 0.2rem;
      // height: 1.68rem;
      .name {
        line-height: 1.1;

        width: 100%;
        height: 0.59rem;
        font-size: 0.28rem;
        font-weight: 500;
        color: #333333;
        margin: 0.16rem 0;
      }
      .price {
        font-size: 0.28rem;
        font-weight: 500;
        color: #00b25a;
      }
    }
  }
}
.tabs {
  display: flex;
  padding: 0.08rem;
  font-size: 0.28rem;
  overflow-x: auto;
  .tab {
    color: rgba(0, 0, 0, 0.5);
    padding: 0.3rem 0 0.16rem;
    margin: 0 0.3rem;
    flex: 1 0 auto;
  }
  .tab_active {
    color: #00b25a;
    border-bottom: solid 0.04rem #00b25a;
    font-weight: bold;
  }
}
.tabs_fixed {
  background: #fff;
  padding-bottom: 0.24rem;
}
.tab-bottom-btn {
  background: #fff;
  padding: 0.16rem 0.32rem;
  font-size: 0.28rem;
  .btn {
    border-radius: 0.64rem;
    display: inline-flex;
    padding: 0.1rem 0.32rem;
    background: rgba(0, 102, 102, 0.1);
    color: #00b25a;
  }
  .btn-active {
    background: #00b25a;
    color: #fff;
  }
}
.activity-box {
  position: relative;
  margin: -0.16rem -0.24rem 0;
  padding: 0.16rem 0.24rem;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1.16rem; /* 顶部300px加00B25A背景 */
    background: #00b25a;
    pointer-events: none;
    z-index: 0;
  }
  .my-swiper {
    height: 2rem;
    padding: 0;
    .swiper,
    img {
      width: 100%;
      height: 100%;
      border-radius: 0.16rem;
    }
  }
}
.no-list {
  text-align: center;
  margin: 1rem 0;
  img {
    width: 190px;
    margin-bottom: 0.2rem;
  }
}
.expire-message {
  border-radius: 4px;
  background: rgba(255, 221, 153, 0.2);
  margin: 0 0.32rem;
  padding: 0.08rem 0.2rem;
  display: flex;
  align-items: center;
  .img {
    width: 18px;
    margin-right: 0.08rem;
  }
  span {
    color: #ff3434;
  }
}
</style>
